'use strict';

const SV = require('server-vars');
const { localStorage, sessionStorage } = require('dibs-browser-storage');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const User = require('../../models/User');
const enabler = require('../../utils/enabler');

const tourActions = require('../../../components/Tour/tourActions');
const { type: { TRADE_TOUR } } = require('../../../components/Tour/TourStore');

const checkUserForTradeBuyer = function checkTradeBuyer() {
    return Promise.resolve(User.load()).then(() => {
        const isVerifiedTradeBuyer = User.getCurrentUser().isVerifiedTradeBuyer();
        const canRequestNetPrice = User.canRequestNetPrice();

        return isVerifiedTradeBuyer && canRequestNetPrice;
    });
};

const tradeTourRule = function tradeTourRule(
    { context },
    { type, limit } = { type: TRADE_TOUR, limit: 3 }
) {
    const session = sessionStorage.getItem(type);
    const storage = localStorage.getItem(type) || 0;
    const isTradeTourDisabled = !enabler.isEnabled('trade_tour');
    const isTradeMessageDisabled = !enabler.isEnabled('trade_welcome_message');
    // A bit hackish way to check the status, but don't want to load item store/model and bloat out the foot.js bundle
    const isNotAvailablePdp = SV.get('rawResult.pricing.purchasable') !== 'Y';
    const isMobile = mobileCheck.any();

    if (
        isMobile ||
        isNotAvailablePdp ||
        session ||
        storage >= limit ||
        isTradeTourDisabled ||
        isTradeMessageDisabled
    ) {
        return Promise.resolve();
    }

    if (User.loggedIn()) {
        return checkUserForTradeBuyer().then(isTradeBuyer => {
            if (isTradeBuyer) {
                context.executeAction(tourActions.setSession, { type });
                context.executeAction(tourActions.increaseSession, { type });
                context.executeAction(tourActions.openTour, { type });
            }

            return { success: isTradeBuyer, type };
        });
    } else {
        return Promise.resolve();
    }
};

module.exports = tradeTourRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/tradeTourRule.es.js